// NATIVE 
import { useEffect, useState } from 'react';


// INSTALLED 
import { Avatar, Card, Chip, Divider, Grid, Typography } from '@mui/material';


// CUSTOM 
import { deepOrange } from '@mui/material/colors';
import { IUserPermissions } from '../../commons/interfaces';
import { mtDividerCardUSer, paddingCardsTables } from '../../commons';






/**
 * CardUserSystemDetails component displays user details in a card format.
 * 
 * @param {IUserPermissions} props - The user permissions object containing user details.
 * @param {any} showButton - An additional prop to control the visibility of a button (not used in the current implementation).
 * 
 * @returns {JSX.Element} A React component that renders user details including avatar, name, email, and status.
 * 
 * @example
 * <CardUserSystemDetails 
 *   id="123"
 *   name="John Doe"
 *   email="john.doe@example.com"
 *   avatar="path/to/avatar.jpg"
 *   status="active"
 *   permissions={['read', 'write']}
 * />
 */
export const CardUserSystemDetails = ( props:IUserPermissions, {showButton}:any) => {


  // USE STATE 
  const [employee, setEmployee] = useState<IUserPermissions>({
    id: 'Cargando...',
    name: 'Cargando...',
    email: 'Cargando...',
    avatar: 'Cargando...',
    status: 'Cargando...',
    permissions: []
  });



  // USE EFFECT 
  useEffect(() => { 
    setEmployee(props);
  }, [props]);


 


  return (
    <>
        <Grid item xs={12} sx={{ position: 'sticky', top: '5rem', zIndex: 1000 }}> 
            <Card
                sx={{
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                    marginTop: paddingCardsTables
                }}
                >

                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem', marginTop: '1rem'}}>
                <Avatar
                    sx={{ bgcolor: deepOrange[500], width: 120, height: 120, textAlign: 'center' }}
                    sizes={'100'}
                    alt="Remy Sharp" 
                    src={employee.avatar}
                    variant='square'
                    >
                    Q
                </Avatar>
                </div>

                <Typography  sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.10rem', marginTop: 4, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> { employee.name } </Typography>

                <Typography  sx={{ textAlign: 'center',  fontSize: '0.9rem',  textTransform: 'capitalize' }}> { employee.email }  </Typography>

                <Typography   sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1rem', marginTop: 4, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> 
                    {
                       employee.status ? <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700, textAlign: 'center' }} /> : <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700, textAlign: 'center' }} />
                    }
                </Typography>   
                
                <Divider sx={{ marginTop: mtDividerCardUSer }}/>
            </Card>
        </Grid>
    </>
  )
}
